import notifService from '@/services/notificaciones.service'

const state = {
  items: [],
  unreadCount: 0,
  loading: false
}

const getters = {
  items: state => state.items,
  unreadCount: state => state.unreadCount,
  loading: state => state.loading
}

const mutations = {
  SET_ITEMS (state, v) { state.items = v },
  SET_UNREAD (state, v) { state.unreadCount = v },
  SET_LOADING (state, v) { state.loading = v }
}

const actions = {
  async fetch ({ commit }) {
    commit('SET_LOADING', true)
    try {
      const data = await notifService.getAll()
      commit('SET_ITEMS', data || [])
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchUnreadCount ({ commit }) {
    const data = await notifService.getUnreadCount()
    commit('SET_UNREAD', data?.count || 0)
  },

  async marcarLeida ({ commit, state }, id) {
    await notifService.marcarLeida(id)
    commit('SET_ITEMS', state.items.map(n => n.id === id ? { ...n, leida: true } : n))
    commit('SET_UNREAD', Math.max(0, state.unreadCount - 1))
  },

  async marcarTodasLeidas ({ commit, state }) {
    await notifService.marcarTodasLeidas()
    commit('SET_ITEMS', state.items.map(n => ({ ...n, leida: true })))
    commit('SET_UNREAD', 0)
  }
}

export default { namespaced: true, state, getters, mutations, actions }
